module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-27-90ca84fc9739b6d36d1008d37f48ed9c.png";